/**
 * Compares 2 version codes as period-delimited strings
 * @param v1 The first version to compare
 * @param v2 The second version to compare
 * @return A positive number if v1 is greater than v2, a negative number if v1 is less than v2, or 0 if they are equal
 */
export function compareVersionsStr(v1: string, v2: string): number {
	return compareVersions(
		v1.split(".").map((s) => parseInt(s, 10)),
		v2.split(".").map((s) => parseInt(s, 10)),
	);
}

/**
 * Compares 2 version codes, split into their version codes
 * @param v1 The first version to compare
 * @param v2 The second version to compare
 * @return A positive number if v1 is greater than v2, a negative number if v1 is less than v2, or 0 if they are equal
 */
export function compareVersions(v1: number[], v2: number[]): number {
	for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
		//One version code is higher than the other (ex. 2.0 VS 1.0)
		const diff = (v1[i] ?? 0) - (v2[i] ?? 0);
		if (diff !== 0) return diff;
		//Version codes are the same; continue and check next version code
	}

	//Values are equal
	return 0;
}
